/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'green-circle-tick': {
    width: 14,
    height: 15,
    viewBox: '0 0 14 15',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7 14.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm3.367-10.423L5.449 9.001 3.621 7.175a.262.262 0 0 0-.372.002l-.671.682a.272.272 0 0 0 .001.382l2.685 2.682a.262.262 0 0 0 .37 0l5.787-5.78a.273.273 0 0 0 0-.384l-.683-.682a.261.261 0 0 0-.371 0z" _fill="#91C38A"/>'
  }
})
